<h5 mat-dialog-title>Upload and Erase Metadata</h5>
<mat-dialog-content>
  <form>
    <div class="form-group">
      <label>Please select your parser</label>
      <select [formControl]='selectControl' class="form-control">
        <option [value]="item.path" *ngFor="let item of parserList">{{ item.parserName }}</option>
      </select>

      <label>Please select your uploader</label>
      <select [formControl]='selectUploader' class="form-control">
        <option value="SAMMS">SAMMS</option>
      </select>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions >
  <button mat-button mat-dialog-close>Close</button>
  <button mat-raised-button color="primary" (click)="postData()">Save Changes</button>
</mat-dialog-actions>
